import axios from "axios";
export const API_URL = "https://techzera.in/ecommerce_demo_api/api/";
// export const API_URL = "http://localhost:80/ecommerce_api/api/";

// export const SITE_URL = "http://localhost:80/ecommerce_api";
export const SITE_URL = "https://techzera.in/ecommerce_demo_api";


export const API = axios.create({ baseURL: API_URL });




